import Icon from '../components/Icon.vue'

Icon.register({
  'headphones-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M160 288c17.7 0 32 14.3 32 32.1v127.9c0 17.7-14.3 32.1-32 32.1h-16c-35.3 0-64-28.7-64-64.1v-63.8c0-35.4 28.7-64.1 64-64.1h16zM368 288c35.3 0 64 28.7 64 64.1v63.8c0 35.4-28.7 64.1-64 64.1h-16c-17.7 0-32-14.4-32-32.1v-127.9c0-17.7 14.3-32.1 32-32.1h16zM256 32c143.1 0 251.4 119.1 256 256v112c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-112c0-114.7-93.3-207.8-208-207.8-114.7 0-208 93.2-208 207.8v112c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-112c4.6-136.9 112.9-256 256-256z'
      }
    ]
  }
})
